import React from "react";
var EyeSlashIcon = function EyeSlashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.574 5.67 13.15 7.092c.278.347.506.664.67.907-.76 1.13-2.85 3.82-5.562 3.985L6.443 13.8c.496.124 1.014.2 1.557.2 4.707 0 7.744-5.284 7.871-5.508a.999.999 0 0 0 .001-.98c-.047-.085-.5-.88-1.298-1.843v.001ZM.294 15.706a.996.996 0 0 0 1.413 0l14-14A1 1 0 1 0 14.293.293l-2.745 2.745C10.515 2.431 9.331 2 8 2 3.245 2 .251 7.29.126 7.514a.998.998 0 0 0 .002.975c.07.125 1.044 1.802 2.693 3.276l-2.529 2.53a.999.999 0 0 0 .001 1.412l.001-.001ZM2.18 8c.778-1.165 2.966-4 5.821-4 .741 0 1.436.201 2.077.508L8.512 6.074A1.924 1.924 0 0 0 8 6a2 2 0 0 0-2 2c0 .178.03.348.074.512L4.24 10.346A12.603 12.603 0 0 1 2.181 8H2.18Z"
  }));
};
EyeSlashIcon.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var EyeIcon = function EyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 4c2.84 0 5.036 2.835 5.818 4-.784 1.166-2.98 4-5.818 4-2.84 0-5.038-2.838-5.819-4.001C2.958 6.835 5.146 4 8.001 4Zm.001 10c4.706 0 7.743-5.284 7.87-5.508a1 1 0 0 0 .001-.98C15.746 7.287 12.732 2 8 2 3.245 2 .251 7.289.126 7.514a.998.998 0 0 0 .002.975C.254 8.713 3.27 14 8 14h.001Zm0-8a2 2 0 1 1 .09 3.999A2 2 0 0 1 8 6Z"
  }));
};
EyeIcon.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tick1Icon = function Tick1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.408 5.349a1.942 1.942 0 0 0 .591-1.387 1.919 1.919 0 0 0-.591-1.387A2.061 2.061 0 0 0 13.978 2a2.06 2.06 0 0 0-1.43.575L5.887 9.037l-2.435-2.36a2.057 2.057 0 0 0-1.43-.576c-.534 0-1.047.207-1.429.575A1.94 1.94 0 0 0 0 8.066a1.916 1.916 0 0 0 .594 1.388l4.253 4.129a1.5 1.5 0 0 0 2.078 0l8.48-8.232"
  }));
};
Tick1Icon.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.757 3.828a1 1 0 0 0 1.415 1.415L7 3.414v7.536a1 1 0 1 0 2 0V3.414l1.829 1.829a1 1 0 1 0 1.414-1.415L8.707.293a1 1 0 0 0-1.414 0L3.757 3.828zM1.5 13a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3h-13z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))));
};
UploadIcon.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var XIcon = function XIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.828 5 3.414.588A2 2 0 0 0 .586 3.415L5 7.829.586 12.243a2 2 0 1 0 2.828 2.83l4.414-4.416 4.414 4.416a2.003 2.003 0 0 0 2.83-2.832l-4.416-4.412 4.416-4.414A2 2 0 0 0 12.24.587L7.828 5Z"
  }));
};
XIcon.defaultProps = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var Eye = EyeIcon;
export var EyeSlash = EyeSlashIcon;
export var Tick1 = Tick1Icon;
export var Upload = UploadIcon;
export var X = XIcon;